import { type IPromotionPage } from '@entities/promotion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalImage } from '@shared/ui/image';
import { CardWrapper } from '@shared/ui/content-containers';
import clsx from 'clsx';

interface IPromoContent {
  mainDomain: string;
  item: IPromotionPage;
  image: string;
  categoryName?: string;
}

const expandDescription = 230;

export function PromoCardMobile({
  item,
  mainDomain,
  image,
  categoryName,
}: IPromoContent) {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();
  const { stockpage_title, description_stock } = item;

  const isCrop = description_stock.length > expandDescription;

  const descriptionContainerStyles = clsx(
    'text-sm text-gray text-left text-ellipsis overflow-hidden',
    {
      'max-h-[46px] overflow-hidden text-ellipsis !line-clamp-2':
        !isOpen && isCrop,
    },
  );

  const toggleDescription = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <CardWrapper className="relative h-full">
      {categoryName && (
        <div className="absolute top-1 left-2.5 bg-(--common-1) px-1 text-base text-white">
          {categoryName}
        </div>
      )}
      <ExternalImage
        src={image}
        mainDomain={mainDomain}
        alt={stockpage_title}
        width={740}
        height={490}
        sizes={{
          mobile: {
            width: 400,
            height: 300,
          },
          tablet: {
            width: 350,
            height: 250,
          },
          desktop: {
            width: 750,
            height: 500,
          },
        }}
      />

      {(stockpage_title || description_stock) && (
        <div className="flex flex-col gap-2 p-2.5">
          <span className="text-base font-medium text-(--black)">
            {stockpage_title}
          </span>
          <button
            type="button"
            className={descriptionContainerStyles}
            onClick={(e) => isCrop && toggleDescription(e)}
          >
            {description_stock}
          </button>
          {isOpen && (
            <div className="mt-[5px] font-medium text-(--primary-1)">
              {t('Stocks.more')} &#8594;
            </div>
          )}
        </div>
      )}
    </CardWrapper>
  );
}
